import store from '../../store/store';

const getState = () => store.getState();

export const basicTrailPlanRestriction = () =>
  `Hello ${
    getState().home?.adminDetails?.firstName
  }, %0D%0A %0D%0A Could you please check this and upgrade the account if required?`;
